import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { pageTop } from "./components/pageTop";
import { videoModal } from "./components/videoModal";
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/dist/css/splide.min.css';



$(document).ready(function () {

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = "#humberge-button";
    const buttonInnerEl = "#humberge-button-inner";
    //ハンバーガーメニュークラス定義
    const menuEl = "#humberge-menu";
    humbergerMenuButton(buttonEl, buttonInnerEl, menuEl);
  });

  // (() => {
  //   /*
  //   スライダー用関数
  //   */
  //   const sliderEl = ".swiper";
  //   slider(sliderEl);
  // })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".tabButton";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".tabContent";
    tab(tabButtonEl, tabContentsEl);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();

  (() => {
    /*
    動画モーダル用関数
    */
    const triggerEl = "[data-video-modal-open]";
    const openBodyClass = "is-video-modal-open";
    videoModal(triggerEl, openBodyClass);
  })();

  (() => {
    /*
    ヘッダーのスクロール状態切り替え
    */
    const $header = $(".l-header");
    const activeScrollTop = 100;

    if (!$header.length) {
      return;
    }

    const toggleHeaderState = () => {
      $header.toggleClass("is-active", $(window).scrollTop() > activeScrollTop);
    };

    toggleHeaderState();
    $(window).on("scroll", toggleHeaderState);
  })();

});

$(function() {
  let splideCheckmain = $('#main-slider').length
  if(splideCheckmain) {
    var splide = new Splide('#main-slider', {
      type   : 'fade',
      rewind: true,
      autoplay: true,
      pagination: true,
      arrows: false,
    });
    splide.mount();
  }
})

$(function() {
  // TOPページ　働き方を知る　自動スライダー
  let splideCheckscroll = $('#slide_topwork').length
  if(splideCheckscroll) {
    const scrollsplide = new Splide('#slide_topwork', {
      type   : 'loop',
      drag   : 'false',
      focus  : 'center',
      perPage: 4,
      arrows : false,
      pagination: false,
      gap: '20px',
      autoScroll: {
          speed: 1,
          pauseOnHover: false,
          pauseOnFocus: false
      },
      breakpoints: {
          768: {
          perPage: 2,
          },
      },
    });
    scrollsplide.mount({ AutoScroll });
  }
});

$(function() {
    let splideCheckstory = $('#slide_story').length;
    if(splideCheckstory) {
      var storysplide = new Splide('#slide_story', {
        type: 'loop',
        updateOnMove: true,
        focus: 0,           // アクティブなスライドを左端に
        // padding: { left: '150px', right: '0' }, // 左端の空きスペースを調整
        perPage: 2.5,
        gap: '20px',
        pagination: true,
        arrows: true,       // HTMLに書いた自作矢印を認識させる
        autoplay: true,
        interval: 5000,
        breakpoints: {
          768: {
            // padding: { left: '20px' },
            perPage: 1,
            focus  : 0,
            padding: "15%", // スライダーの左右の余白
            gap: 10, // スライド間の余白
          }
        }
      });

      storysplide.mount();

      // 再生・一時停止の切り替え
      const toggleBtn = document.getElementById('story_toggle_btn');
      toggleBtn.addEventListener('click', function() {
        const { Autoplay } = storysplide.Components;
        if (Autoplay.isPaused()) {
            Autoplay.play();
            toggleBtn.classList.remove('is-paused');
        } else {
            Autoplay.pause();
            toggleBtn.classList.add('is-paused');
        }
      });
    }
});

$(function() {
  let splideCheckloadmap = $('#slide_loadmap').length
  if(splideCheckloadmap) {
    var splide = new Splide('#slide_loadmap', {
      autoplay: false, // 自動再生
      type: "slide", // ループさせる
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
      interval: 3000, // 自動再生の間隔
      speed: 2000, // スライダーの移動時間
      destroy: true, // スライダーを破棄
      pagination: true,
      gap: '20px',
      padding: {
        left: 0,         // 左は詰め
        right: '10%',    // 右側に次のスライドを10%分チラ見せ
      },
      arrows: false,       // HTMLに書いた自作矢印を認識させる
      breakpoints: {
        768: {
          destroy: false, // 768px未満でスライダー開始
        },
      },
    });
    splide.mount();
  }
})

$(function() {
  let splideCheckintroduction = $('#slide_introduction').length;
  if(splideCheckintroduction) {
    var introductionsplide = new Splide('#slide_introduction', {
      // type: 'loop',
      // focus  : 'center', // 中央をメインに
      // gap    : '20px',   // スライド間の余白
      // pagination: true,
      // arrows: true,       // HTMLに書いた自作矢印を認識させる
      // autoplay: true,
      // interval: 5000,
      updateOnMove: true,
      autoplay: true, // 自動再生
      type: "loop", // ループ
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
      interval: 5000, // 自動再生の間隔
      speed: 1000, // スライダーの移動時間
      padding: "30%", // スライダーの左右の余白
      gap: 25, // スライド間の余白
      breakpoints: {
          768: {
              // padding: { left: '20px' },
            perPage: 1,
            focus  : 0,
            padding: "15%", // スライダーの左右の余白
            gap: 10, // スライド間の余白
          }
        }
    });

    introductionsplide.mount();

    // 再生・一時停止の切り替え
    const toggleBtn = document.getElementById('introduction_toggle_btn');
    toggleBtn.addEventListener('click', function() {
      const { Autoplay } = introductionsplide.Components;
      if (Autoplay.isPaused()) {
          Autoplay.play();
          toggleBtn.classList.remove('is-paused');
      } else {
          Autoplay.pause();
          toggleBtn.classList.add('is-paused');
      }
    });
  }
});

$(function() {
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  const $btn = $(".p-footer__main__parent__btn");
  const $allChild = $(".p-footer__main__child"); // 全ての子要素

  function handleFooterMenu(e) {
    if (e.matches) {
      // 【PC時】リセット
      $btn.off("click");
      $btn.removeClass("active");
      $allChild.removeAttr("style");
    } else {
      // 【スマホ時】
      $btn.on("click", function() {
        const $thisBtn = $(this);
        const $thisChild = $thisBtn.parent().next(".p-footer__main__child");

        // 1. 自分以外の「開いているメニュー」を閉じる
        $btn.not($thisBtn).removeClass("active");
        $allChild.not($thisChild).stop().slideUp();

        // 2. 自分のメニューを切り替える
        $thisBtn.toggleClass("active");
        $thisChild.stop().slideToggle();
      });
    }
  }

  handleFooterMenu(mediaQuery);
  mediaQuery.addEventListener('change', handleFooterMenu);
});

// $(function() {
//   const mediaQuery = window.matchMedia('(min-width: 768px)');
//   const $btn = $(".p-header__nav__list__item__btn");

//   function handleMenu(e) {
//     // 一旦全てのイベントを解除し、スタイルをリセット
//     $btn.off(); 
//     $btn.removeClass("active");
//     $(".p-header__nav__list__childitem").hide();

//     if (e.matches) {
//       // 【PC時】ホバーで開閉
//       $btn.on({
//         "mouseenter": function() {
//           $(this).addClass("active");
//           $(this).next(".p-header__nav__list__childitem").stop().slideDown();
//         },
//         "mouseleave": function() {
//           $(this).removeClass("active");
//           $(this).next(".p-header__nav__list__childitem").stop().slideUp();
//         }
//       });
//     } else {
//       // 【スマホ時】クリックで開閉
//       $btn.on("click", function() {
//         $(this).toggleClass("active");
//         $(this).next(".p-header__nav__list__childitem").stop().slideToggle();
//       });
//     }
//   }

//   // ページ読み込み時に実行
//   handleMenu(mediaQuery);

//   // 画面幅が変更された時にも実行（リサイズ対策）
//   mediaQuery.addEventListener('change', handleMenu);
// });

$(function() {
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  const $item = $(".p-header__nav__list__item"); // 親要素
  const $btn = $(".p-header__nav__list__item__btn"); // ボタン
  const $allChild = $(".p-header__nav__list__childitem");

  function handleMenu(e) {
    // 全てのイベントを一旦解除し、状態をリセット
    $item.off();
    $btn.off(); 
    $btn.removeClass("active");
    $allChild.hide();

    if (e.matches) {
      // 【PC時】親要素（item）に対してホバーを判定
      $item.on({
        "mouseenter": function() {
          const $targetBtn = $(this).find(".p-header__nav__list__item__btn");
          const $targetChild = $(this).find(".p-header__nav__list__childitem");
          
          $targetBtn.addClass("active");
          $targetChild.stop().slideDown();
        },
        "mouseleave": function() {
          const $targetBtn = $(this).find(".p-header__nav__list__item__btn");
          const $targetChild = $(this).find(".p-header__nav__list__childitem");
          
          $targetBtn.removeClass("active");
          $targetChild.stop().slideUp();
        }
      });
    } else {
      // 【スマホ時】クリックした項目のみ開き、他は閉じる
      $btn.on("click", function() {
        const $thisBtn = $(this);
        const $thisChild = $thisBtn.next(".p-header__nav__list__childitem");

        $btn.not($thisBtn).removeClass("active");
        $allChild.not($thisChild).stop().slideUp();

        $thisBtn.toggleClass("active");
        $thisChild.stop().slideToggle();
      });
    }
  }

  handleMenu(mediaQuery);
  mediaQuery.addEventListener('change', handleMenu);
});

$(function() {
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  const $toggleBtn = $("#togglebtn");
  const $toggleBtnInner = $("#togglebtn-inner");
  const $toggleMenu = $("#toggle-menu");
  const $header = $(".l-header");
  const $menuText = $toggleBtn.find(".menutext");

  if (!$toggleBtn.length || !$toggleBtnInner.length || !$toggleMenu.length || !$header.length) {
    return;
  }

  function setToggleMenuState(isOpen) {
    $toggleBtnInner.toggleClass("active", isOpen);
    $toggleMenu.toggleClass("active", isOpen);
    $header.toggleClass("is-menu-open", isOpen);
    if ($menuText.length) {
      $menuText.text(isOpen ? "close" : "menu");
    }
  }

  function resetToggleMenu() {
    setToggleMenuState(false);
  }

  $toggleBtn.on("click", function () {
    setToggleMenuState(!$toggleMenu.hasClass("active"));
  });

  function handleBreakpointChange(e) {
    if (e.matches) {
      resetToggleMenu();
    }
  }

  handleBreakpointChange(mediaQuery);
  mediaQuery.addEventListener('change', handleBreakpointChange);
});

$(function() {
  const $faqToggleBtn = $(".p-faq__question");
  const $faqAnswerBody = $(".p-faq__answerbody");

  $faqToggleBtn.on("click", function() {
    const $thisBtn = $(this);
    const $thisAnswer = $thisBtn.next($faqAnswerBody);

    // 2. 自分の回答を切り替える
    $thisBtn.toggleClass("active");
    $thisAnswer.stop().slideToggle();
  })
});

$(window).on('scroll', function() {
  $('.c-marker').each(function() {
    var elemPos = $(this).offset().top; // 要素の位置（上端）
    var scroll = $(window).scrollTop(); // 現在のスクロール位置
    var windowHeight = $(window).height(); // ブラウザの高さ

    // 要素が画面の「下から20%」の位置まで来たら発火
    if (scroll > elemPos - windowHeight + (windowHeight * 0.2)) {
      $(this).addClass('is-active');
    }
  });
});
